import { useModal } from 'components/Modal';
import NameForm from 'presets/NameForm';
import { rename } from 'presets/data/queryKeyFactory';
import { screenPresets } from 'presets/data/queryKeyFactory';
import { Preset } from 'presets/interfaces';
import { updatePreset } from 'presets/sources/updatePreset';
import { useMutation, useOptimisticUpdate } from 'query';

export const useRenamePreset = (screenKey: readonly unknown[]) => {
  const [openNameForm] = useModal(NameForm);
  const { onMutate, onError, onSettled } = useOptimisticUpdate({
    queryKey: screenPresets(screenKey),
    optimisticUpdate: (changedData: Preset, previousData: Preset[]) => {
      return (previousData as Preset[]).map(preset => {
        if (preset.id === changedData.id) {
          return changedData;
        }
        return preset;
      });
    },
  });

  const updateMutation = useMutation(rename(), updatePreset, {
    successMessage: () => `Preset renamed`,
    refresh: false,
    onMutate,
    onError,
    onSettled,
  });

  const handleAction = async (changedPreset: Preset) => {
    const name = await openNameForm({
      title: 'Rename Preset',
      screenKey,
      initialValue: changedPreset.title,
    });
    return updateMutation.mutateAsync({ ...changedPreset, title: name } as any);
  };

  return [handleAction, updateMutation];
};
